<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入直播间ID" v-model="params.roomId" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入直播事件ID" v-model="params.eventId" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择状态" size="small">
                        <el-option value="" label="所有状态"></el-option>
                        <el-option :value="1" label="启用"></el-option>
                        <el-option :value="0" label="禁用"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/live/roomProgram/create')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" @click="add" size="small">新增节目</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" size="mini" type="success">正常</el-tag>
                        <el-tag v-else size="mini" type="info">禁用</el-tag>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="liveEventIds" label="绑定直播事件ID"></el-table-column>
                <el-table-column prop="liveRoomIds" label="绑定直播间ID"></el-table-column> -->
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/live/roomProgram/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <template v-if="$utils.have('/live/roomProgram/updateStatus')">
                            <el-button
                                v-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                icon="el-icon-remove-outline"
                                @click="editStatus(scope.row.id,0)"
                                >禁用</el-button
                            >
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                icon="el-icon-circle-check"
                                @click="editStatus(scope.row.id,1)"
                                >启用</el-button
                            >
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit ref="dataEdit" @update="getDataList"></edit>
    </div>
</template>
<script>
import Edit from './components/edit'
const defaultParams = {
    pageNo: 1,
    roomId:'',
    eventId:'',
    status:''
}
    export default {
        components:{Edit},
        data(){
            return {
                data: null,
                dataList: null,
                params: {
                    ...defaultParams,
                    pageSize: this.$pageSizes[0]
                },
                listLoading: true
            }
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            //获取列表
            getDataList(){
                this.listLoading = true;
                this.$request({
                    url: '/live/roomProgram/list',
                    method: 'POST',
                    data: this.params
                }).then(res => {
                    const { state, msg, result } = res.data;
                    if( state == 1 && result ){
                        this.data = result;
                        this.dataList = result.result || [];
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            },
            //选择pageSize
            handleSizeChange( e ){
                this.params.pageNo = 1
                this.params.pageSize = e
                this.getDataList()
            },
            //搜索
            search() {
                this.params.pageNo = 1;
                this.getDataList();
            },
            //重置搜索
            reset() {
                this.params = {
                    ...defaultParams,
                    pageSize: this.params.pageSize
                }
                this.getDataList();
            },
            //改变状态
            editStatus(id,status){
                const _msg = status === 0 ? '确定要禁用吗?' : '确定要启用吗?';
                this.$confirm(_msg, '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/live/roomProgram/updateStatus',
                        method: 'POST',
                        params: {id:id,status:status}
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.getDataList();
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                })
            },
            //新增事件
            add(){
                this.$refs.dataEdit.show();
            },
            //编辑事件
            edit(id) {
                this.$refs.dataEdit.show(id);
            }   
        }
    }
</script>